/** Legal line used in the site footer and copyright. */
export const COMPANY_LEGAL_NAME = "Memara, a product of EcoImpact Ventures Inc.";
